// ========= src/redux/sagas/familyMemberSaga.js =========
import { call, put, takeLatest } from "redux-saga/effects";
import * as types from "./actionTypes";
import * as actions from "./actions";
import axiosInstance from "../instance/AxiosInstance";

export const fetchFamilyMembersApi = (customerId) => {
  return axiosInstance.get(`/family/allListByPatientId`, {
    params: {
      pagination_required: true,
      customer_id: customerId
    }
  });
};

function* fetchFamilyMembersSaga(action) {
  try {
    const customerId = action.payload?.customerId;

    const response = yield call(fetchFamilyMembersApi, customerId);

    const familyMembers = response.data.data || [];

    yield put(actions.fetchFamilyMembersSuccess(familyMembers));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.message ||
      "Failed to fetch family members";
    yield put(actions.fetchFamilyMembersFailure(errorMessage));
  }
}

function* fetchFamilyMemberSaga(action) {
  try {
    const response = yield call(
      axiosInstance.get,
      `/family/details?family_id=${action.payload}`
    );

    yield put(actions.fetchFamilyMemberSuccess(response.data));
  } catch (error) {
    const errorMessage = error.response
      ? error.response.data.message
      : error.message;
    yield put(actions.fetchFamilyMemberFailure(errorMessage));
  }
}

function* addFamilyMemberSaga(action) {
  try {
    const response = yield call(
      axiosInstance.post,
      "/family/insert",
      action.payload
    );
    yield put(actions.addFamilyMemberSuccess(response.data));
  } catch (error) {
    yield put(actions.addFamilyMemberFailure(error.message));
  }
}

function* updateFamilyMemberSaga(action) {
  try {
    const { id, ...familyMemberData } = action.payload;

    const response = yield call(
      axiosInstance.put,
      `/family/update/${id}`,
      familyMemberData
    );

    yield put(actions.updateFamilyMemberSuccess(response.data));
  } catch (error) {
    yield put(
      actions.updateFamilyMemberFailure(
        error.response?.data?.message || "Failed to update family member"
      )
    );
  }
}
function* deleteFamilyMemberSaga(action) {
  try {
    yield call(axiosInstance.delete, `/family/delete/${action.payload}`);
    yield put(actions.deleteFamilyMemberSuccess(action.payload));
  } catch (error) {
    yield put(actions.deleteFamilyMemberFailure(error.message));
  }
}

export function* familyMemberWatcherSaga() {
  yield takeLatest(types.FETCH_FAMILY_MEMBERS_REQUEST, fetchFamilyMembersSaga);
  yield takeLatest(types.FETCH_FAMILY_MEMBER_REQUEST, fetchFamilyMemberSaga);
  yield takeLatest(types.ADD_FAMILY_MEMBER_REQUEST, addFamilyMemberSaga);
  yield takeLatest(types.UPDATE_FAMILY_MEMBER_REQUEST, updateFamilyMemberSaga);
  yield takeLatest(types.DELETE_FAMILY_MEMBER_REQUEST, deleteFamilyMemberSaga);
}
